import React, { Component, Fragment } from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { translate } from 'react-i18next';
import Modal from 'react-modal';
import { blockUnblockUser, addSystemMessage } from '../../../actions/index';
import { Icon } from '../Icon';
import cx from '../../../styles';
import Loader from '../Loader';
import { gtmSend } from '../../../helpers';
// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
if(typeof window != 'undefined') {
    Modal.setAppElement('#root');
}

class BlockUnblockUser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            title: '',
            content: '',
            loading: false,
            isShowNotification: true,
        };
    }

    onSubmit = (e) => {
        e.preventDefault();
        let entityType = this.props.entityType;
        switch(entityType) {
            case 'answer': 
                entityType = 'reply';
              break;
            case 'boothComment': 
              entityType = 'booth_comment';
            break;
        }
        this.setState({loading: true})
        this.props.blockUnblockUser(entityType, this.props.entityId, this.props.status, this.props.type)
            .then((res)=>{
                if(res.data && res.data.status){
                    this.setState({loading: false})
                    this.props.addSystemMessage({id: Math.random(), message: this.props.blockUser? this.props.t('block_user_success') : this.props.t('unblocking_success'), level: 'success'});
                    this.eventTracking();
                    setTimeout(()=>{
                        if(this.props.detailPage || (['answer', 'comment'].indexOf(this.props.type) !== -1 && this.props.postReducer && this.props.postReducer.data && this.props.postReducer.data.topic && this.props.postReducer.data.topic.user_id === this.props.userId)){
                            window.location = '/feed'
                        }else if(this.props.type === 'boothComment' && this.props.memoryReducer && this.props.memoryReducer.data && this.props.memoryReducer.data.booth && this.props.memoryReducer.data.booth.user_id === this.props.userId){
                            window.location = '/booth'
                        }else{
                           (this.props.resetPage || ['answer', 'comment','boothComment'].indexOf(this.props.type) !== -1 || this.props.entityType === 'profile' || this.props.subType === 'author') && !this.props.blockReply && this.props.type !== 'blockList'? window.location.reload() : '';
                        }
                    },500)
                    this.onModalClose();
                    this.props.toggleReply && this.props.toggleReply();
                }   
                else{
                    this.setState({loading: false})
                    res && res.data && res.data.message && this.props.addSystemMessage({id: Math.random(), message: res.data.message, level: 'error'})
                    this.onModalClose();
                }
            })
            .catch((err)=>{
                console.log(err)
                this.setState({loading: false})
                this.onModalClose();
            })
    }

    eventTracking = () => {
        const sendEvent = (cardType) => {
            return gtmSend(this.props.blockUser? 'user_block' : 'user_unblock', cardType, this.props.blockUser? 'User Block' : 'User Unblock', this.props.topic? this.props.topic.name : '--', 0, {card_type: cardType, card_id: this.props.id, group_id: this.props.topic? this.props.topic.id : '--', group_name: this.props.topic? this.props.topic.name : '--', reported_user_id: this.props.userId})
        }
        switch(this.props.cardName) {
            case 'Question Card':
                sendEvent('post');
            break;
            case 'Poll Card':
                sendEvent('poll');
            break;
            case 'Reply Card':
                gtmSend(this.props.blockUser? 'user_block' : 'user_unblock', 'Reply', this.props.blockUser? 'User Block' : 'User Unblock', this.props.topic? this.props.topic.name : '--', 0, {card_type: 'Reply', card_id: this.props.postId, reply_id: this.props.id, group_id: this.props.topic? this.props.topic.id : '--', group_name: this.props.topic? this.props.topic.name : '--', reported_user_id: this.props.userId})
            break;
            case 'Reply Comment Card':
                gtmSend(this.props.blockUser? 'user_block' : 'user_unblock', 'Comment', this.props.blockUser? 'User Block' : 'User Unblock', this.props.topic? this.props.topic.name : '--', 0, {card_type: 'Comment', card_id: this.props.postId, comment_id: this.props.id, group_id: this.props.topic? this.props.topic.id : '--', group_name: this.props.topic? this.props.topic.name : '--', reported_user_id: this.props.userId})
            break;
            case 'User Profile':
                gtmSend(this.props.blockUser? 'user_block' : 'user_unblock', 'User', 'User Profile', this.props.blockUser? 'User Block' : 'User Unblock', 0, {reported_user_id: this.props.userId, screen: 'User Profile'})
            break;
            default:
                sendEvent(this.props.type);
        }
    }

    openModal = () => {
        this.setState({isOpen: true});
    }

    onModalOpen = () => {
        this.props.blockUser && this.props.userName? 
        this.setState({title: this.props.t('blocking_user'),content: this.props.t('blocking_user_content')})
        :
        this.setState({title: this.props.t('unblocking_user'), content: this.props.t('unblocking_user_content')})
        if(this.props.userName === 'Anonymous' && !this.props.userId){
            this.setState({content: this.props.t('blocking_anonymous_user')})
        }
    }

    onModalClose = () => {
        this.setState({isOpen: false, title: '', content: '', loading: false});
        this.props.toggleModal? this.props.toggleModal() : '';
    }

    render() {
        const t = this.props.t;

        return (
            <Fragment>
                {this.props.postCard && <span onClick={this.openModal}>{this.props.blockUser? t('block_user') : t('unblock_user')}</span>}
                <Modal isOpen={this.props.isOpen || this.state.isOpen}
                    onAfterOpen={this.onModalOpen}
                    onRequestClose={this.onModalClose}
                    overlayClassName="block-unblock-user-modal"
                    style={this.customStyles} >
                    
                    <div className="block-user-component">
                        {this.state.loading && <Loader />}
                        <span className={cx("close-modal")} onClick={this.onModalClose}>
                            <Icon name="cross-regular-dark-smd" />
                        </span>
                        <div className={cx("wrapper")}>
                            <span>
                                {this.props.blockUser? <Icon name="block-user-regular" /> : <Icon name="unblock-user-regular" />}
                            </span>
                            <p className={cx('title')}>{this.state.title}</p>
                            <p className={cx('content')}>{this.state.content}</p>
                            <button className={cx('button')} onClick={(e)=>this.onSubmit(e)}>{t('confirm')}</button>
                        </div>
                    </div>
                </Modal>
            </Fragment>
        );
    }
}

//map state
const mapStateToProps = (state) => {
    // console.log(state);
    return state;
}

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        blockUnblockUser,
        addSystemMessage
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(BlockUnblockUser));
